export const SELF_TYPE_CD = [
  { label: "자진발급", value: "0" },
  { label: "자진발급 아님", value: "1" },
];

export const CSHPT_USG_CL_CD = [
  { label: "소득공제", value: "0" },
  { label: "지출증빙", value: "1" },
];

export const CSHPT_TRS_TYPE_CD = [
  { label: "과세", value: "01" },
  { label: "면세", value: "02" },
];

export const SPST_CNFR_CL_CD = [
  { label: "주민등록번호", value: "01" },
  { label: "사업자등록번호", value: "02" },
  { label: "휴대폰번호", value: "03" },
  { label: "카드번호", value: "04" },
];

export const CSHPT_CNCL_RSN_CD = [
  { label: "거래취소", value: "1" },
  { label: "오류발급", value: "2" },
  { label: "기타", value: "3" },
]